import noHistoryIcon from "../../../../assets/icons/noHistory.svg";

const NoHistoryView = ({ msg }) => {
  return (
    <div className="flex justify-center items-center lg:pt-28 pt-5">
      <div>
        <img
          src={noHistoryIcon}
          alt="history icon"
          className="mx-auto lg:w-28"
        />
        <p className="pt-6">{msg}</p>
      </div>
    </div>
  );
};

export default NoHistoryView;
